<template>
  
  <div id="app">
    <router-view />
  </div>
</template>

<!--全体共通Style-->
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: start;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #4d4e4e;

    &.router-link-exact-active {
      color: #3e495a;
    }
  }
}
/*文字寄せ*/
.left-input input {
  text-align: left;
}

.center-input input {
  text-align: center;
}

.right-input input {
  text-align: right;
}

/*画面構成・大枠*/
.vMainBackArea {
  background-color: whitesmoke;
}

.itemAreaSize{
  max-width:60em;
  margin-left: auto;
  margin-right: auto;
}

/*画面構成・大枠*/
.itemArea {
  padding-top: 0.9em;
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 0.3em;
  margin-bottom: 0.9em;  
  background-color: white; 
  box-shadow: 0 0 0.3em lightgray;
}

/*画面構成・大枠*/
.itemAreaMessage {
  padding-left: 1em;
  padding-right: 1em;
}

/*画面構成・項目名*/
.itemTitle {
  font-weight: bold;
  margin-top: 0.3em;
  margin-bottom: 0.3em;
  width: fit-content;
  color:dimgray;
}

/*画面構成・項目名*/
.itemTitle_Group {
  font-weight:400;
  margin-top: 0.3em;
  padding-left: 1em;
  padding-right: 1em;
  width: fit-content;
  background-color:dimgray;
  color:rgb(255, 255, 255);
}

/*画面構成・項目名*/
.itemTitle_Right {
  font-weight: bold;
  margin-top: 0.3em;
  margin-bottom: 0.3em;
  margin-right: 0.3em;
  color:dimgray;
  text-align: right;
}

/*画面構成・項目のデータ内容*/
.itemData {
  margin-top: 0.3em;
  margin-bottom: 0.3em;
  width: fit-content;
}

/*画面構成・コメント*/
.itemComent{
  margin-top: 0.5em;  
  font-size: 80%;
  width: fit-content;  
}

/*画面構成・メッセージ*/
.itemMessage {
  margin-top: 0.3em;
  margin-bottom: 0.3em;
  width: fit-content;
  color:#1751a7;
}

.itemError {
  margin-top: 0.3em;
  margin-bottom: 0.3em;
  width: fit-content;
  color:#ffadad;
}

.ScreenMessage {
  margin-top: 0.3em;
  margin-bottom: 0.3em;
  width: fit-content;
  color:#b7fcff;
}

/*画面構成・入力項目*/
.itemTextInput {
  margin-top: 0.3em;  
  margin-bottom: 0.3em;
  width: 95%;
  text-align: left;
}

.itemTextInput_Group {
  margin-top: 0.3em;  
  margin-bottom: 0.3em;
  width: 95%;
  text-align: left;
  border-bottom:2px solid dimgray;
}

/*メニューテキスト・タイトル;*/
.itemTitleMenu{
  text-align: left;
  font-weight: bold;
  font-size: 0.9em;  
}
/*メニューテキスト・本文*/
.itemTitleMenu2{
  text-align: left;
  font-size: 0.9em;
  padding-left: 1em;  
}

/*線タイトル*/
.divider_gropu_title{
  margin-top: -0.8em; 
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 1em;
}

v-main{
  max-width: 1200px;
}

</style>

<script>

export default {
  data: () => ({
    drawer: null ,
    MenuTitle: '杯王 Web+' 
  }),
  methods: {
    setMeta(route) {
      // タイトルを設定
      if (route.meta.title) {
        let setTitle = route.meta.title;
        document.title = setTitle;
      }
      // ディスクリプションを設定
      if (route.meta.desc) {
        let setDesc = route.meta.desc;
        document.querySelector("meta[name='description']").setAttribute('content', setDesc)
      }
    }
  },
  mounted() {
    let route = this.$route;
    this.setMeta(route);
  },
  watch: {
    '$route'(route) {
      this.setMeta(route);
    }
  }
}
</script>
